module.exports = __webpack_public_path__ + "static/image010-8819f1df48d2cf980e59b541c30c92a6.jpg";